import request from "../router/request";

const url = process.env.NODE_ENV === 'production' ? '/api' : '/api';

// 文章列表
export const getList = (typeId, cateId, page, keyword) => {
  var     limit = 10
  if (typeId==1){
    limit = 9
  }
  return request({
    url: url + '/index/index',
    method: 'get',
    params: {
      type_id: typeId,
      cate_id: cateId,
      limit: limit,
      page: page,
      keyword: keyword
    }
  })
}

// 类别管理
export const getCate = (pid) => {
  return request({
    url: url + '/index/cate',
    method: 'get',
    params: {
      pid
    }
  })
}

// 文章详情
export const getDetail = (id) => {
  return request({
    url: url + '/index/detail',
    method: 'get',
    params: {
      id
    }
  })
}

// 轮播图详情
export const getBanner = () => {
  return request({
    url: url + '/index/banner',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js